import { makeCommsPage } from './commsPage'
import { CommsModelsView } from '../components/views/commsModelsView'

export default makeCommsPage({
    title: 'AI models',
    intro: 'Which models each comms task calls, what they cost, and how often they agree.',
    probeUrl: 'comms/models/list',
    View: CommsModelsView,
    className: 'commsModels',
})
